import { create } from 'zustand';

const KEY = 'sa_current_business';

function load() {
  try {
    return localStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export const useBusinessStore = create((set) => ({
  currentBusinessId: load(),
  setCurrentBusiness: (id) => {
    try {
      if (id) localStorage.setItem(KEY, String(id));
      else localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
    set({ currentBusinessId: id ? String(id) : '' });
  },
}));

export default useBusinessStore;
